import axios from '../../../../shared/authAxios';
import { endpoints } from '../../../../api/endpoints';

export const userService = {
  list,
  fullList,
  save,
  load,
  deleteUser,
  sendVerificationToken,
  verifyEmailToken
};

function list({ rowsPerPage, page, sortBy, sortDirection, query, exactFields, exactValues }) {
  return axios({
    'url': endpoints.acl.user.list,
    'method': 'POST',
    'data': {
      rowsPerPage,
      page,
      sortBy: [sortBy === "id" ? "_id" : sortBy],
      sortDirection: [sortDirection.toUpperCase()],
      query,
      exactFields, 
      exactValues
    },
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function fullList(extend) {
  const postData = {
    rowsPerPage: 65000,
    page: 0,
    sortBy: ["_id"],
    sortDirection: ["ASC"],
    fields: ["_id", "username"],
  };

  if (extend) {
    const keys = Object.keys(extend);
    keys.forEach(key => {
      postData[key] = extend[key];
    });
  }

  return axios({
    'url': endpoints.acl.user.list,
    'method': 'POST',
    'data': postData,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (r.data.rows == null) r.data.rows = [];
        return r.data
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function save(user) {
  let method = "POST";
  let url = endpoints.acl.user.save

  if (user.id) {
    method = "PUT"
    url += "/" + user.id
  }

  delete (user.id)

  return axios({
    'url': url,
    'method': method,
    'data': user,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.data.user;
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return Promise.reject(err);
        } else {
          return Promise.reject(err.response.data);
        }
      }

      return Promise.reject(err);
    })
}

function load(id) {
  let method = "GET";
  let url = endpoints.acl.user.save + '/' + id

  return axios({
    'url': url,
    'method': method,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.data.user;
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function deleteUser(id, errcb, succb) {
  let method = "POST";
  let url = endpoints.acl.user.delete + '/' + id

  return axios({
    'url': url,
    'method': method,
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        if (typeof succb === 'function') succb();
        return r.data.deleted;
      }
    })
    .catch(err => {
      if (typeof errcb === 'function') errcb(err);
      if (err.response && err.response.data) {
        if (typeof err.response.data === 'string') {
          return err
        } else {
          return err.response.data;
        }
      }

      return err;
    })
}

function sendVerificationToken(userID) {
  const url = `${endpoints.acl.user.sendToken}/${userID}`;  
console.log(url)
  return axios({
    url: url,
    method: "POST",
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.message;  // Return success message
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === "string") {
          return Promise.reject(err);
        } else {
          return Promise.reject(err.response.data);
        }
      }
      return Promise.reject(err);
    });
}

function verifyEmailToken(userID, token) {
  const url = `${endpoints.acl.user.checkToken}/${userID}`;

  return axios({
    url: url,
    method: "POST",
    data: { Code:token },  // Pass token in request body
  })
    .then(response => {
      const r = response.data;

      if (r.success) {
        return r.message;  // Return success message
      }
    })
    .catch(err => {
      if (err.response && err.response.data) {
        if (typeof err.response.data === "string") {
          return Promise.reject(err);
        } else {
          return Promise.reject(err.response.data);
        }
      }
      return Promise.reject(err);
    });
}

